$(function() {
    // Initialize
    $("#newsletter").click(function(e) {
        e.preventDefault();
        var params = {
            email: $('#newsletter_email').val()
        };
        $.ajax({
            url: '/layouts/components/_newsletter.php',
            dataType: 'html',
            data: params,
            type: 'POST',
            success: function(response) {
                if (response == 1) {
                    alert('Se ha suscripto correctamente.');
                } else {
                    alert('El correo introducido ya existe en nuestra base de datos.');
                }
            }
        });
    });
});


// WEBPACK FOOTER //
// ./assets/js/newsletter.js